import { connect } from 'react-redux';

import { SocialLoginButtons } from '@eb/social-login-facebook';

import {
    socialLogInUserNotAuthorized as socialLogInUserNotAuthorizedAction,
    socialLogInUserAuthorized as socialLogInUserAuthorizedAction,
} from '../actions/social';

const _mapStateToProps = ({ authentication }) => ({
    socialSSOSettings: authentication.socialSSOSettings,
});

const _mapDispatchToProps = {
    onSocialConnectNotAuthorized: socialLogInUserNotAuthorizedAction,
    onSocialLogInUserAuthorized: socialLogInUserAuthorizedAction,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(SocialLoginButtons);
